import app from '@/app';
import templateUrl from './unifilarParameters-detail.html';

/* @ngInject */
function Controller($controller, UnifilarParameters, ConstantSet, Principal, GrowthRate, AlertService, $state) {
	var $ctrl = this;

	$ctrl.currentAccount = null;

  $ctrl.allRateType = ["FIXED", "VARIABLE"];

	$controller('AbstractEntityDetailController', {
		$ctrl,
		resource: UnifilarParameters,
		type: 'unifilarParameters'
	});

	// Override save to use 'entity.update.message' (async Plan module)
	$ctrl.save = () => {
		if (!$ctrl.readonly) {
			$ctrl.isSaving = true;
			const onSuccess = () => {
				AlertService.success('entity.update.message', {
					type: $ctrl.type,
					name: $ctrl.entity.name
				});
				$ctrl.isSaving = false;
				$state.go('^', {}, { reload: true });
			};
			const onError = error => {
				$ctrl.isSaving = false;
			};
			if ($ctrl.entity.id) {
				UnifilarParameters.update($ctrl.entity, onSuccess, onError);
			} else {
				UnifilarParameters.create($ctrl.entity, onSuccess, onError);
			}
		}
	};

  Principal.identity().then(account => {
	$ctrl.currentAccount = account;
	})

	$ctrl.unifilarParametersSave = () => {
		$ctrl.entity.plantype = 'P21';
		$ctrl.entity.segmentLength = 1;
		$ctrl.entity.requestedYears = 1;
		$ctrl.save();
	};

	$ctrl.onRoadSelected = road => {
		$ctrl.entity.road = road;
		$ctrl.entity.headMilestone = road.headMilestone;
		$ctrl.entity.tailMilestone = road.tailMilestone;
	};

	$ctrl.onOrganizationChange = organization => {
		$ctrl.entity.road = null;
		$ctrl.entity.campaign = null;
	};

	$ctrl.byOrganization = value =>
		$ctrl.entity.organization && value.organization.id == $ctrl.entity.organization.id;

	$ctrl.byOwner = value =>
		$ctrl.entity.organization && value.owner.id == $ctrl.entity.organization.id;

    $ctrl.queryGrowthRates = query => {
      $ctrl.loading = true;
      return GrowthRate.query({ query: query, size: 10, sort: 'name,asc' }, data => {
        $ctrl.allGrowthRates = data;
        $ctrl.loading = false;
      }).$promise;
    };

}

app.component('unifilarParametersDetail', {
	templateUrl,
	controller: Controller,
	require: {
		parent: '^unifilarParametersSearch'
	},
	bindings: {
		$transition$: '<',
		entity: '<'
	}
});
